import { render } from "./CartFooter.vue?vue&type=template&id=5e05d962"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__